var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"tw-min-h-screen tw-h-full tw-absolute tw-z-0 tw-inset-0 tw-w-full tw-filter tw-blur-3xl tw-opacity-20",attrs:{"src":_vm.src,"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }